@file:UseSerializers(InstantIso8601Serializer::class)

package com.ijoin.data.model

import com.ijoin.data.model.serialization.InstantIso8601Serializer
import kotlinx.datetime.Instant
import kotlinx.serialization.Serializable
import kotlinx.serialization.UseSerializers

@Serializable
data class TimeSlot(
    val id: Long,
    val serviceProviderId: Long? = null,
    val serviceProviderName: String? = null,
    val startTime: Instant,
    val endTime: Instant,
    val status: TimeSlotStatus? = null,
    val notes: String? = null,
)

@Serializable
enum class TimeSlotStatus {
    AVAILABLE,
    BOOKED,
    BLOCKED,
}

@Serializable
data class CreateBookingRequest(
    val clientId: Long? = null,
    val eventId: String,
    val timeSlotIds: List<Long>,
    val clientNotes: String? = null,
)
